import Client from '../HttpClient';

const list = () => {
	return Client.get('/admin/api/cloudmenu/list');
};

const confirm = () => {
	return Client.post(`/admin/api/cloudmenu/confirm/update`);
};

export default {
	list,
	confirm,
};
